<template>
  <div class="pt-5 pb-5">
    <v-card class="pl-5 pr-5">
      <h2>Assign BiblioTech Collections</h2>
      <v-divider></v-divider>
      <Notification :notify="notify" />

      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4">
              Assign New Collection
            </v-btn>
          </div>
        </div>
      </div>

      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col">
              <v-combobox
                v-model="selectedObj.collections"
                :items="collections"
                :search-input.sync="searchCollection"
                :menu-props="{ closeOnClick: false, disableKeys: true }"
                item-text="Name"
                item-value="id"
                hide-selected
                label="Add Collection to the Organization"
                persistent-hint
                return-object
                @change="onChangeCollections"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </div>
            <div class="col">
              <v-text-field
                v-model="selectedObj.NoOfSeats"
                label="No Of Seats"
                type="number"
                required
                :rules="seatRules"
              ></v-text-field>
            </div>
            <div class="col" v-show="false">
              <!--:rules="startDateRules"-->
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedStartDateFormatted"
                    label="Start Date"
                    hint="MM/DD/YYYY format"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="col">
                 <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      :rules="endDateRules"
                      label="End Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
            </div>
          </div>
        </v-form>
      </div>

      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row mb-4">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="onCancel()"> Cancel </v-btn>
                <v-btn
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
      </div>

      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Description</th>
                  <th class="text-left" style="width: 200px">No Of Seats</th>
                  <th class="text-left" style="width: 200px">End Date</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.collections.Name }}</td>
                  <td>{{ item.collections.Description }}</td>
                  <td>{{ item.NoOfSeats }}</td>
                  <td>{{ item.endDate | dateUtcToLocal }}</td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import * as api from "@/api";
export default {
  name: "PurchasedCollections",
  components: {
    Notification,
    Pagination,
    ConfirmationDialog,
  },
  props: {
    organization: { type: Object, required: true },
  },
  created() {
    //this.getEtbnCollection();
    this.getPurchasedCollectionsByPagin();
  },
  computed: {
    computedStartDateFormatted() {
      return this.formatDate(this.startDate);
    },
    computedDateFormatted() {
      return this.formatDate(this.endDate);
    },
  },
  watch: {
    organization: function (val) {
      console.log("organization " + val.id);
      this.organizationId = val.id;
      this.getNotOrganizationCollection(val.id);
      this.getPurchasedCollectionsByPagin();
    },
  },
  methods: {
    onSearch() {
      this.paging.keyword = this.Search;
      this.paging.page = 1;
      this.getPurchasedCollectionsByPagin();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getPurchasedCollectionsByPagin();
    },
    getNotOrganizationCollection(id) {
      this.selectedObj.collections = [];
      new Promise((resolve, reject) => {
        api
          .getByID("collection/not-organization-collection", id)
          .then((response) => {
            for (let i = 0; i < response.data.length; i++) {
              this.collections.push(response.data[i]);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getEtbnCollection() {
      this.collections = [];
      new Promise((resolve, reject) => {
        api
          .getAll("collection/etbn-collection")
          .then((response) => {
            this.collections = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getPurchasedCollectionsByPagin() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .postPaginByOrganization(
            "organization-purchases",
            this.paging,
            this.organizationId
          )
          .then((response) => {
            console.log(response.data.data);
            this.list = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onNew() {
      this.isEdit = true;
      this.id = 0;
      this.valid = false;
      this.selectedObj.id = 0;
      this.selectedObj.collections = [];
      this.selectedObj.NoOfSeats = 0
      this.endDate = null;
      this.startDate = new Date().toISOString().substr(0, 10);

      this.getNotOrganizationCollection(this.organizationId);
    },
    onSave() {
      console.log('onSave')
      this.$refs.form.validate();
      console.log('onSave 2') 
      this.selectedObj.startDate = this.computedStartDateFormatted;
      this.selectedObj.endDate = this.computedDateFormatted;
      this.selectedObj.organization = this.organization;
      console.log('onSave 3') 
      console.log(this.selectedObj);

      //if (!this.valid) return;

      new Promise((resolve, reject) => {
        api
          .update("organization-purchases", this.selectedObj)
          .then((response) => {
            resolve(response);
            console.log(response.status);
            console.log(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
              this.getPurchasedCollectionsByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            reject(error);
          });
      });

      this.isEdit = false;
      this.$refs.form.reset();
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
      this.endDate =
        obj.endDate == null
          ? null
          : new Date(obj.endDate).toISOString().substr(0, 10);
      this.startDate =
        obj.startDate == null
          ? null
          : new Date(obj.startDate).toISOString().substr(0, 10);
      //this.getOrganizationCollection(this.organization.id);
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("organization-purchases", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getPurchasedCollectionsByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
      this.$refs.form.reset();
    },
    onChangeCollections(items) {
      for (let i = 0; i < items.length; i++) {
        if (!(typeof this.selectedObj.collections[i] === "object")) {
          items.splice(i, 1);
          break;
        }
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
  },
  data() {
    return {
      id: 0,
      organizationId: 0,
      list: [],
      collections: [],
      isEdit: false,
      isNew: false,
      Search: "",
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      valid: false,
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      collectionRules: [(v) => v || "Collection is required"],
      seatRules: [(v) => !!v || "Seat is required"],
      selectedObj: {
        id: 0,
        collections: [],
      },
      searchCollection: null,
      Search: "",
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      menu1: false,
      menu2: false,
      endDate: "",
      startDate: "",
      startDateRules: [(v) => !!v || "Start date is required"],
      endDateRules: [(v) => !!v || "End date is required"],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/PurchasedCollections.vue